import React, { useState } from 'react'
import { Icon } from '../../atoms/Icon'
import { FeaturesListProps } from './FeaturesList.types'
import {
  FeaturesContainer,
  FeaturesGrid,
  FeatureItem,
  FeatureIcon,
  FeatureText,
  ShowMoreButton,
} from './FeaturesList.styles'

export const FeaturesList: React.FC<FeaturesListProps> = ({
  features,
  columns = 3,
  minColumnWidth = '180px',
  showAllInitially = false,
  maxItemsBeforeCollapse = 9,
  containerProps,
  className,
}) => {
  const [showAll, setShowAll] = useState(showAllInitially)
  const hasMoreItems = features.length > maxItemsBeforeCollapse
  const displayedFeatures =
    showAll || !hasMoreItems
      ? features
      : features.slice(0, maxItemsBeforeCollapse)

  return (
    <FeaturesContainer
      $background={containerProps?.background}
      $padding={containerProps?.padding}
      $borderRadius={containerProps?.borderRadius}
      className={className}
    >
      <FeaturesGrid $columns={columns} $minColumnWidth={minColumnWidth}>
        {displayedFeatures.map((feature, index) => (
          <FeatureItem key={index}>
            <FeatureIcon>
              <Icon name="check" size="small" />
            </FeatureIcon>
            <FeatureText>{feature.text}</FeatureText>
          </FeatureItem>
        ))}
      </FeaturesGrid>

      {hasMoreItems && (
        <ShowMoreButton onClick={() => setShowAll(!showAll)}>
          <span>
            {showAll ? 'Show Less' : `View All ${features.length} Features`}
          </span>
          <Icon name={showAll ? 'arrow-up' : 'arrow-down'} size="small" />
        </ShowMoreButton>
      )}
    </FeaturesContainer>
  )
}
